// @flow

/**
 * Module dependencies.
 */

import { ifProp } from 'styled-tools';
import styled from 'styled-components';

/**
 * Export `List` component.
 */

export const List = styled.ul`
  display: inline-block;
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

/**
 * Export `ListItem` component.
 */

export const ListItem = styled.li`
  display: ${ifProp('block', 'block', 'inline')};
  float: ${ifProp('block', 'none', 'left')};
  margin: ${ifProp('block', '8px 0', '0 8px')};
  padding: 0;
`;



// WEBPACK FOOTER //
// ../src/client/components/core/lists.js